
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic16 as ObiHydraulic16Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-16.js';
 
 
 

 
 export const ObiHydraulic16 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-16',
   elementClass: ObiHydraulic16Element,
   events: {
     
   }
  });
 
 